<template>
  <div class="create-org">
    <el-dialog
      title="提交成功"
      :visible.sync="visible"
      width="600px"
      top="26vh"
      :close-on-click-modal="false"
      :before-close="
        done => {
          close()
        }
      "
    >
      <div class="create-org-body">
        <p>请点击【下一步】前往企业控制台完成企业实名。</p>
      </div>
      <div slot="footer" class="auth-dialog-footer">
        <el-button class="submit btn-primary" type="primary" @click="submit">下一步</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'confirm',
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    submit() {
      window.location.href = `${process.env.VUE_APP_SAAS_URL}/index`
      this.close()
    },
  },
}
</script>
<style lang="less" scoped>
.create-org {
  .create-org-body {
    padding: 16px 24px;
    position: relative;
  }
  /deep/ .el-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #e4e4e4;
    }
    .el-dialog__footer {
      border-top: 1px solid #e4e4e4;
      padding: 14px 20px 15px;
    }
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    color: #999999;
  }
  @media (max-width: 750px) {
    .el-dialog__wrapper {
      z-index: 100001 !important;
      height: 100vh;
      background: #ffffff;
    }
    /deep/ .el-dialog {
      width: 100% !important;
      height: 100%;
      margin: 0 !important;
      .el-dialog__header {
        border: none;
        background: #f7f8fa;
        text-align: center;
        padding: 12px 20px 12px;
        .el-dialog__headerbtn {
          top: 12px;
        }
      }
      .el-dialog__body {
        padding: 0;
        max-height: calc(100% - 105px);
      }
      .el-dialog__footer {
        padding: 0 18px;
        border: none;
      }
      .auth-dialog-footer {
        padding: 8px 0;
        .back-btn {
          display: none;
        }
      }
    }
  }
}
</style>
